import { PropsWithChildren } from 'react';
import { classNames } from '@vkontakte/vkui';
import styles from './InstallPage.module.css';

interface InstallPage extends PropsWithChildren {
  className?: string;
}

export function InstallPage(props: InstallPage) {
  const { children, className } = props;

  return <div className={classNames(styles.root, className)}>{children}</div>;
}
